"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditModeMessage = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
exports.EditModeMessage = function () { return (react_1.default.createElement("div", { className: "s-extended-date-filter-edit-mode-message gd-extended-date-filter-edit-mode-message" },
    react_1.default.createElement("div", { className: "gd-extended-date-filter-edit-mode-message-text" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "dateFilterDropdown.setDefault", values: {
                nbsp: react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"),
            } })),
    react_1.default.createElement("hr", { className: "gd-separator-generic" }))); };
//# sourceMappingURL=EditModeMessage.js.map